import useUAIP from "./useUAIP";

export default useUAIP;